<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    @if (cart) {
      <ion-title>
        @if (!cart.quote_id) {
          <span>Create quote</span>
        }
        @if (cart.quote_id) {
          <span>Update quote</span>
        }
      </ion-title>
    }
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="processQuote()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                <ion-input #reference_input type="text" inputmode="text" maxlength="100" labelPlacement="stacked" fill="outline" [(ngModel)]="params['reference']" (keydown.enter)="processQuote()">
                  <div slot="label">Reference<ion-text class="optional">optional</ion-text></div>
                </ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                @if (params['expiry_date']) {
                  <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" value={{formatted_expiry_date}} (click)="presentDateTimePickerModal()">
                    <div slot="label">Expiry date<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
                @if (!params['expiry_date']) {
                  <ion-input class="modal-input" readonly="true" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()">
                    <div slot="label">Expiry date<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>